import _get from 'lodash/get';

import { parseJSON, parseString } from './helper';

export const setCurrentEntity = (entity: any) => {
	localStorage.setItem('entity', entity);
};

export const getCurrentEntity = () => {
	return localStorage.getItem('entity');
};

export const setFilters = (filters: any) => {
	filters.forEach((value: any, key: any) => {
		const selection = _get(value, 'selection');
		if (selection && selection instanceof Set) {
			localStorage.setItem(`selection-${key}`, parseString(Array.from(selection)));
		}
	});
	localStorage.setItem('filters', parseString(Array.from(filters)));
};

export const getFilters = () => {
	const lsFilters = localStorage.getItem('filters');
	const filters = new Map(parseJSON(lsFilters) as any);
	filters.forEach((value: any, key: any) => {
		const selection = localStorage.getItem(`selection-${key}`);
		if (selection) {
			// eslint-disable-next-line no-param-reassign
			value.selection = new Set(parseJSON(selection) as any);
		}
	});

	return filters;
};

export const getEntityFilters = (entity: any) => {
	const currentEntity = getCurrentEntity();

	if (currentEntity && entity === currentEntity) {
		return getFilters();
	}

	setCurrentEntity(entity);
	setFilters(new Map());

	return new Map();
};

export const setInitialFilters = (entity: any, filters: any) => {
	const currentEntity = getCurrentEntity();

	if (!currentEntity || currentEntity !== entity) {
		setCurrentEntity(entity);
	}
	setFilters(filters);
};

export const getInitialFilters = (entity: any, initialFilters: any) => {
	const currentEntity = getCurrentEntity();

	if (!currentEntity || currentEntity !== entity) {
		setCurrentEntity(entity);
		setFilters(initialFilters);
		return initialFilters;
	}

	return getFilters();
};

export const addFilter = (entity: any, filterKey: any, filterDesc: any) => {
	const currentFilters = getEntityFilters(entity);
	currentFilters.set(filterKey, filterDesc);
	setFilters(currentFilters);
};

export const removeFilter = (entity: any, filterKey: any) => {
	const currentFilters = getEntityFilters(entity);
	currentFilters.delete(filterKey);
	setFilters(currentFilters);
};
